var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',{style:({
    '--nav-width': '0px',
  })},[_c('div',{staticClass:"h-full w-full"},[_c('nuxt')],1),_vm._v(" "),_c('portal-target',{attrs:{"name":"slideovers","multiple":""}}),_vm._v(" "),_c('portal-target',{attrs:{"name":"popover","slim":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }